export const letter = {

	bind: function (el, binding) {

		if (!binding.value) return;

		let handler = e => {
			if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
				// Allow: Ctrl+A
				(e.keyCode === 65 && e.ctrlKey === true) ||
				// Allow: Ctrl+C
				(e.keyCode === 67 && e.ctrlKey === true) ||
				// Allow: Ctrl+X
				(e.keyCode === 88 && e.ctrlKey === true) ||
				// Allow: Ctrl+V
				(e.keyCode === 86 && e.ctrlKey === true) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				// let it happen, don't do anything
				return
			}
			// Ensure that it is a number and stop the keypress
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault()
			}
		}

		let clear = e => {
			e.target.value = e.target.value.replace(/\D/g, '');
		}

		el.onlyNumeric = handler;
		el.cleanNunNumeric = clear;

		el.addEventListener('keydown', handler);
		el.addEventListener('keyup', clear);

	},
	unbind: function (el) {
		el.removeEventListener("click", el.onlyNumeric);
		el.removeEventListener("click", el.cleanNunNumeric);
	}
}